import req from './http.js'

// 取得預約資料
export const apiGetReservationData = params => req('post', '/proxy/directus/getReservationData', params)
